import { convertPersianToEnglish } from '@/utilities/convertPersianToEnglishNumber';

export const VALIDATION_PHONE_NUMBER_IS_INVALID_MESSAGE = 'شماره همراه وارد شده معتبر نیست.';
export const VALIDATION_NATIONAL_ID_IS_INVALID_MESSAGE = 'کد ملی وارد شده معتبر نیست.';
export const VALIDATION_REQUIRED_FILED_MESSAGE = 'این فیلد الزامی است.';
export const VALIDATION_ONLY_PERSIAN_CHARACTERS_MESSAGE = 'فقط از حروف فارسی استفاده کنید.';

export const addressFieldMinLength = 20;

export const validationRegex = {
    phoneNumberRegex: /^([۰-۹]{2}|09)[۰-۹\d]{9}$/,
    onlyPersianCharacters: /^[\u0621-\u06CC\s]+$/
};

export const testValidations = (regex: any, value: any) => {
    return regex.test(value);
};

export const nationalIdValidation = (nationalID: string) => {
    if (nationalID) {
        if (nationalID?.length > 10) {
            return false;
        }
        const code = convertPersianToEnglish(nationalID);
        const last = parseInt(code[9], 10);
        const num =
            [0, 1, 2, 3, 4, 5, 6, 7, 8]
                .map(function (n) {
                    return parseInt(code[n], 10) * (10 - n);
                })
                .reduce(function (code, n) {
                    return code + n;
                }) % 11;
        return (num < 2 && last === num) || (num >= 2 && last + num === 11);
    }
    return true;
};
